
import {
    Container,
    Graphics,
    Rectangle
} from 'pixi.js';
import { LoadContext, DisposableGroup } from '../../utils';
import { Game } from '../../game';
import { Settings } from '../../settings';
import { Focusable, UILabel, InteractiveWrapper, Switch } from '../../ui';

export class DwellPanel extends Container {

    protected label:UILabel;
    protected game:Game;
    protected settings:Settings;
    protected icon_x:number = 40;
    protected icon_y:number = 20;
    protected title_vo:string;
    protected explain_vo:string;
    protected settings_vo:string;
    protected disposables: DisposableGroup;
    private switch: Switch;

    public static preload() {
        LoadContext.current.add('TitleAtlas', './assets/title/TitleAtlas{size}.json');
        Switch.preload(true);
        UILabel.preload();
    }

    constructor( game: Game)
    {
        super();
        this.disposables = new DisposableGroup();
        this.game = game;

        const title = 'Switch Access';
        const vo = {
            title: "CYB_Panel_Dwell",
            explain: 'CYB_Panel_DwellSettings',
            settings: 'CYB_Panel3_DwellSelected',
        }
        this.settings = this.game.settings;
        this.title_vo = vo.title;
        this.explain_vo = vo?.explain;
        this.settings_vo = vo.settings;

        const loader = LoadContext.current;

        if (title)
        {
            this.label = new UILabel(
                title,
                {
                    align: 'center',
                    fontName: 'AsapMedium',
                    fontSize: 33,
                    tint: 0xffffff
                },
                loader.getTexture('icon_question_title', 'TitleAtlas')
            );
            this.disposables.add(new InteractiveWrapper(this.label, {
                onHover: async () => {
                    await this.game.vo.playHighlight( [this.title_vo, this.settings_vo] );
                },
                onTap: async () => {
                    this.game.vo.stop();
                    await this.game.vo.playVO( this.explain_vo );
                },
                onActivate: async () => {
                    this.game.vo.stop();
                    await this.game.vo.playVO( this.explain_vo );
                    await this.game.vo.playVO(this.settings_vo);
                }
            }));
            this.label.position.set( 30, 0 );
            this.addChild( this.label );
        }

        this.switch = new Switch(true);
        this.switch.position.set( 0, 50 );
        this.updateToMatchSetting();

        this.switch.on( "switchChanged", (newValue:boolean)=>{
            this.game.vo.stop();
            this.game.settings.enableDwellClicks.value = newValue;
            this.game.settings.showRestArea.value = newValue;
            const eventName: string = newValue ? "dwell_activation_on" : "dwell_activation_off";
            this.game.logEvent("change_setting", eventName);
            this.playSwitchVO( this.switch );
        });
        this.disposables.add(new InteractiveWrapper(this.switch, {
            onHover: () => {
                this.playSwitchHover( this.switch );
            },
            onTap: () => {},
            forceDwell: true
        }));
        this.addChild( this.switch );
    }

    public get shouldPlayAD()
    {
        return this.settings.playAudioDescriptions.value;
    }

    public getFocusItems():Focusable[]
    {
        let ret:Focusable[] = this.label ? [ this.label ] : [];
        return ret.concat( [this.switch] );
    }

    protected getSize()
    {
        const target = this.switch;
        return {width: target.width, height: target.height};
    }

    updateToMatchSetting()
    {
        this.switch.isOn = this.game.settings.enableDwellClicks.value;
        this.game.settings.showRestArea.value = this.game.settings.enableDwellClicks.value;
    }

    protected playSwitchHover( theSwitch:Switch ) : Promise<void>
    {
        let ret:Promise<void>;
        if( theSwitch.isOn ) {
            ret = this.game.vo.playHighlight( [this.title_vo, 'CYB_Panel1_On'], false );
        } else {
            ret = this.game.vo.playHighlight( [this.title_vo, 'CYB_Panel1_Off'], false );
        }
        return ret;
    }

    protected playSwitchVO( theSwitch:Switch ) : Promise<void>
    {
        let ret:Promise<void>;
        if( theSwitch.isOn ) {
            ret = this.game.vo.playVO( [this.title_vo, 'CYB_Panel1_On'], false );
        } else {
            ret = this.game.vo.playVO( [this.title_vo, 'CYB_Panel1_Off'], false );
        }
        return ret;
    }

    destroy()
    {
        this.disposables.dispose();
        super.destroy({children: true});
    }
}